/**
 * @owner @Appboy/core-objects
 */
export const customObjectsTypeNameExternalIdObjectRelationships =
  "/custom_objects/:type_name/:external_id/object_relationships" as const;
